export default "__VITE_ASSET__DiqjmFj8__"